// 注册全局组件
// 页脚
import PageFooter from '@cmpt/Footer'
// 登录后页头
import PageHeader from '@cmpt/PageHeader'
// 表格+分页
import TTable from '@cmpt/TTable'
import TDate from '@cmpt/TDate'

// 国内机票航段明细
import FlyDetail from '@cmpt/FlyDetail'
// 国内机票退改签、行李
import RefundChangeRule from '@cmpt/RefundChangeRule'
// 国内机票城市控件
import CityBox from '@cmpt/City'
// 火车票城市控件
import TrainCity from '@cmpt/TrainCityBox'
// 酒店城市控件
import HotelCity from '@cmpt/HotelCityBox'

// 树
import tree from '@cmpt/Ztree'
// 移动端
import AppHeader from '@cmpt/AppHeader'
import AppFooter from '@cmpt/AppFooter'
function plugin (Vue) {
  if (plugin.installed) {
    return
  }
  Vue.component('pageFooter', PageFooter)
  Vue.component('PageHeader', PageHeader)
  Vue.component('TTable', TTable)
  Vue.component('TDate', TDate)
  Vue.component('tree', tree)
  Vue.component('FlyDetail', FlyDetail)
  Vue.component('RefundChangeRule', RefundChangeRule)
  Vue.component('CityBox', CityBox)
  Vue.component('TrainCity', TrainCity)
  Vue.component('HotelCity', HotelCity)
  Vue.component('AppHeader', AppHeader)
  Vue.component('AppFooter', AppFooter)
}
export default plugin



// WEBPACK FOOTER //
// ./src/utils/globalComponents.js